module.exports = __webpack_public_path__ + "static/media/more.80d5a136.svg";